import { POST_API } from "../utils/api";
import { API_DOMAIN } from "../utils/domain";

export const fetchCVE = async (cve_id) => {
  try {
    const bodyData = {
      cve_id: cve_id, 
    };
// console.log("bodyData", bodyData);
    const result = await POST_API(`${API_DOMAIN}/api/v1/first-org/cve/getCveDetails`, bodyData);
// console.log("result", result);
    if (result.success) {
      return {
        success: true,
        message: 'CVE data retrieved successfully',
        data: result.data, 
      };
    } 
    else {
      return {
        success: false,
        message: result.error ,
      };
    }
  } catch (error) {
    console.error('Error fetching CVE data:', error);
    return {
      success: false,
      message: 'Error fetching CVE data. Please try again later.',
    };
  }
};

export const fetchBulkCVEs = async (body) => {
  try {
    const result = await POST_API(`${API_DOMAIN}/api/v1/first-org/cve/getBulkCveDetails`, body);
    
    if (result.success) {
      return {
        success: true,
        message: 'Bulk CVE data retrieved successfully',
        data: result.data,
      };
    } else {
      return {
        success: false,
        message: result.message || 'Failed to fetch data',
      };
    
      }
  } catch (error) {
    console.error('Error fetching bulk CVE data:', error);
    return {
      success: false,
      message: 'Error fetching bulk CVE data. Please try again later.',
    };
  
  }
}